import { render, staticRenderFns } from "./PresetList.vue?vue&type=template&id=3b7e06e8"
import script from "./PresetList.vue?vue&type=script&lang=js"
export * from "./PresetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports